const GUIDE_SUGGESTION_CANONICAL_BY_ACTION: Record<string, string> = {
  'presupuestos-obra': 'analizar-docs-obra-cotizaciones'
}

export function resolveGuideSuggestionCanonicalId(
  actionId?: string | null
): string | undefined {
  if (!actionId) return undefined
  return GUIDE_SUGGESTION_CANONICAL_BY_ACTION[actionId] ?? actionId
}

export function guideMessageMatchesSuggestion(
  messageActionId: string | undefined | null,
  suggestionId: string | undefined
): boolean {
  if (!messageActionId || !suggestionId) return false
  return resolveGuideSuggestionCanonicalId(messageActionId) === suggestionId
}
